import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

type dataSets = {
  data: number[]
  backgroundColor: string[]
}

type BarChartProps = {
  labels: number[]
  datasets: {
    data: number[]
    backgroundColor: string[]
    borderWidth: number
  }[]
}
/**
 * Gera um gráfico de barras e retorna a imagem em base64.
 */
export const getBarChartBase64 = ({ labels, datasets }: BarChartProps): string => {
  const canvas = document.createElement('canvas')
  canvas.width = 450 * 2;
  canvas.height = 226 * 2;


  new Chart(canvas, {
    type: 'bar',
    data: {
      labels,
      datasets: datasets,
    },
    options: {
      responsive: false,
      animation: false as false,
      plugins: {
        legend: {
          display: false, 
          
        },
      },
      scales: {
        x: {
          display: false, // Remove o eixo X (índices)
        },
        y: {
          display: true, // Remove o eixo Y (valores)
        },
      },
    },
  })

  return canvas.toDataURL() // Base64 direto
}
